import { Collection, Model } from 'web-mojo';

class VendingTransaction extends Model {
    constructor(data = {}) {
        super(data, {
            endpoint: '/api/payments/transaction'
        });
    }

    amountFormatted() {
        const cents = this.get('amount');
        const currency = this.get('currency') || 'USD';
        if (!cents && cents !== 0) return '—';
        return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);
    }

    machineName() {
        return this.get('machine')?.name || '—';
    }

    canRefund() {
        return this.get('status') === 'captured';
    }
}

class VendingTransactionList extends Collection {
    constructor(options = {}) {
        super({
            ModelClass: VendingTransaction,
            endpoint: '/api/payments/transaction',
            ...options
        });
    }
}

export { VendingTransaction, VendingTransactionList };
